export const MONTHS_RO = [
  "Ianuarie", "Februarie", "Martie", "Aprilie", "Mai", "Iunie",
  "Iulie", "August", "Septembrie", "Octombrie", "Noiembrie", "Decembrie",
];

export const DAY_LETTERS = ["D", "L", "Ma", "Mi", "J", "V", "S"];

// Valori pontaj (identice cu referința)
export const PONTAJ_OPTIONS = [
  { value: "8", label: "8 ore" },
  { value: "6", label: "6 ore" },
  { value: "4", label: "4 ore" },
  { value: "2", label: "2 ore" },
  { value: "CO", label: "Concediu odihnă" },
  { value: "CM", label: "Concediu medical" },
  { value: "CFP", label: "Concediu fără plată" },
  { value: "NM", label: "Absență nemotivată" },
  { value: "DEM", label: "Demisie" },
  { value: "CNC", label: "Concediu naștere copil" },
  { value: "CD", label: "Concediu deces" },
];

export const classFor = (val) => {
  if (val === null || val === undefined || val === "") return "bg-white";
  if (/^\d+$/.test(String(val))) return "bg-green-100 text-green-800";
  const map = {
    CO: "bg-blue-100 text-blue-700",
    CM: "bg-orange-100 text-orange-700",
    CFP: "bg-yellow-100 text-yellow-700",
    NM: "bg-red-100 text-red-700",
    DEM: "bg-purple-100 text-purple-700",
    CNC: "bg-pink-100 text-pink-700",
    CD: "bg-stone-300 text-stone-700",
    X: "bg-slate-200 text-slate-500",
  };
  return map[val] || "bg-white";
};
